import React, { FC } from 'react'

import Container from '@Components/CMS/Container'
import { TrustPilotWidget } from '@Components/TrustPilotWidget'

import styles from './Trustpilot.module.scss'

interface TrustPilotProps {
  id?: string
}
const TrustPilot: FC<TrustPilotProps> = ({ id }) => (
  <div className={styles.trustpilot} id={id}>
    <Container style={{ marginBottom: 0 }} width="medium">
      <TrustPilotWidget />
    </Container>
  </div>
)

export default TrustPilot
